// import { store } from '@/store/store'
import {
    temAcesso
} from '@/bibliotecas/seguranca/authLib'

const Importacoes = () => import('./Importacoes.vue')

export default {
    path: 'importacoes',
    name: 'Painel_Importacoes',
    component: Importacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('PAINEL-IMPOR-00')) {
            next()
        }
    }
}



// WEBPACK FOOTER //
// ./src/modulos/paineis/importacoes/ImportacoesRotas.js